import Reveal from "@/components/site/Reveal";
import { Icon } from "@/components/site/Icon";
import { INDUSTRIES_WE_SERVE, WHATSAPP_LINK } from "@/data/content";
import { FaArrowRight } from "react-icons/fa6";

const Industries = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative bg-gold-light py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1300px] px-6 md:px-10">
        <Reveal className="mb-14 max-w-3xl">
          <p className="mb-4 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.25em] text-gold-primary">
            <span className="h-px w-8 bg-gold-primary" /> Sectors & Industries
          </p>
          <h2 className="font-display text-4xl font-extralight leading-[1.05] tracking-tightest text-green-primary md:text-6xl">
            Industries We Serve Across <span className="italic text-gradient-gold">India & Beyond.</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-green-primary md:text-lg font-medium">
            Our domain-specialized recruitment leads deep dive into sector nuances
            to deliver talent aligned with operational goals.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {INDUSTRIES_WE_SERVE.map((ind, i) => (
            <Reveal
              key={ind.title}
              delay={(i % 4) * 0.06}
              className="group relative flex flex-col justify-between rounded-3xl border border-gold-soft bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:border-gold-primary hover:shadow-luxe"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-green-primary text-xl text-gold-primary transition-transform duration-300 group-hover:scale-110 group-hover:bg-gold-primary group-hover:text-white">
                    <Icon name={ind.icon} />
                  </span>
                  <span className="text-[10px] font-bold uppercase tracking-widest text-gold-primary">
                    Industry
                  </span>
                </div>

                <h3 className="mt-5 text-xl font-bold text-green-primary transition-colors group-hover:text-gold-primary">
                  {ind.title}
                </h3>

                <p className="mt-2 text-xs leading-relaxed text-green-primary font-medium">
                  {ind.desc}
                </p>
              </div>

              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-green-primary transition-colors hover:text-gold-primary"
              >
                Hire in {ind.title}
                <FaArrowRight className="text-[10px] transition-transform group-hover:translate-x-1" />
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
